<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: true,
    },
    totalPages: {
        type: Number,
        default: 1,
    },
    currentPage: {
        type: Number,
        default: 1,
    },
    limit: {
        type: Number,
        default: 3,
    },
    content: {
        type: String,
        default: 'Blog Post',
    },
});

const emit = defineEmits(['changePage']);

const changePage = (page) => {
    emit('changePage', page);
};
</script>

<template>
    <div>
        <MessPagination v-if="totalPages > 1 && !loading" :totalPages="totalPages" :currentPage="currentPage"
            @changePage="changePage" :limit="limit" :content="content" class="text-[var(--magenta)] font-hubspot-sans">
            <template #left-arrow>
                <MessSvg type="paginationLeft" />
            </template>
            <template #right-arrow>
                <MessSvg type="paginationRight" />
            </template>
        </MessPagination>
    </div>
</template>

<style>
/* Child component overrides — targets elements inside MessPagination */
.mess-pagination ul {
    gap: 1.5rem;
}

@media (max-width: 768px) {
    .mess-pagination ul {
        gap: 0.25rem;
    }

    .mess-pagination ul li a {
        min-width: 24px;
    }
}

.mess-pagination a:hover {
    border-color: transparent;
}

.mess-pagination a:focus {
    border: 2px dotted var(--dark-pink);
}

.mess-pagination .arrow {
    color: var(--magenta);
    margin: 0 1rem;
}

@media (hover: hover) {
    .mess-pagination .arrow:hover:not(.disabled) {
        cursor: pointer;
    }

    .mess-pagination .arrow:hover:not(.disabled) svg {
        color: #820CA7;
    }
}

.mess-pagination .arrow.disabled {
    color: var(--dark-pink);
    opacity: 0.5;
}

.mess-pagination .number {
    color: #804768;
}

.mess-pagination .number.active {
    color: var(--magenta);
    font-weight: 400;
}

@media (hover: hover) {
    .mess-pagination .number:hover {
        color: #820CA7;
    }
}
</style>
